module.exports = ".column-container {\r\n    width: 100%;\r\n    max-width: 1140px;\r\n}"


//////////////////
// WEBPACK FOOTER
// ./src/app/links/list-links/list-links.component.css
// module id = ./src/app/links/list-links/list-links.component.css
// module chunks = main